import React, { useState, useMemo } from "react";
import LovUser from "./LovUser";
import LovMenu from "./LovMenu";

import { useAuth } from "component/UseAuth";

const DataMenu = ({ users, menus, onSelectUser, onSaveAccess, onSaveAll }) => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    menu_id: "",
    menu_root: "",
    menu_desc: "",
  });

  const [showUserLov, setShowUserLov] = useState(false);
  const [showMenuLov, setShowMenuLov] = useState(false);
  const [selectedSubMenus, setSelectedSubMenus] = useState([]);

  const lovMenus = menus.filter((m) => m.menu_type === "L");

  const subMenus = useMemo(() => {
    if (!formData.menu_desc) return [];
    const selectedRoot = formData.menu_root.toString();
    return menus.filter(
      (m) =>
        (m.menu_type === "M" || m.menu_type === "S") &&
        m.menu_root.toString().startsWith(selectedRoot)
    );
  }, [formData.menu_root, menus]);

  const handleSubMenuToggle = (menu) => {
    if (selectedSubMenus.some((m) => m.menu_id === menu.menu_id)) {
      setSelectedSubMenus(
        selectedSubMenus.filter((m) => m.menu_id !== menu.menu_id)
      );
    } else {
      setSelectedSubMenus([...selectedSubMenus, menu]);
    }
  };

  return (
    <>
      {/* CARD UTAMA */}
      <div className="card p-2 mb-2">
        {/* Input Nama Lengkap */}
        <div className="row mb-1 align-items-center">
          <label
            className="col-sm-4 col-form-label col-form-label-sm"
            style={{ fontSize: "0.75rem" }}
          >
            Nama Lengkap
          </label>
          <div className="col-sm-8">
            <div className="d-flex align-items-center gap-1">
              <input
                type="text"
                className="form-control form-control-sm"
                style={{ fontSize: "0.75rem", height: "26px" }}
                value={formData.name || ""}
                readOnly
              />
              <button
                type="button"
                className="btn btn-sm btn-secondary"
                style={{ fontSize: "0.75rem", height: "26px" }}
                onClick={() => setShowUserLov(true)}
                title="Pilih User"
              >
                <i className="fa fa-ellipsis-h"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Input Menu Level L */}
        <div className="row mb-1 align-items-center">
          <label
            className="col-sm-4 col-form-label col-form-label-sm"
            style={{ fontSize: "0.75rem" }}
          >
            Data Menu
          </label>
          <div className="col-sm-8">
            <div className="d-flex align-items-center gap-1">
              <input
                type="text"
                className="form-control form-control-sm"
                style={{ fontSize: "0.75rem", height: "26px" }}
                value={formData.menu_desc || ""}
                readOnly
              />
              <button
                type="button"
                className="btn btn-sm btn-secondary"
                style={{ fontSize: "0.75rem", height: "26px" }}
                onClick={() => setShowMenuLov(true)}
                title="Pilih Menu"
              >
                <i className="fa fa-ellipsis-h"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Tampilkan Submenu */}
        {formData.menu_desc && (
          <div className="mt-2 border-top pt-2">
            <h6 style={{ fontSize: "0.8rem" }}>
              Menu di bawah <strong>{formData.menu_desc}</strong>
            </h6>

            {subMenus.length > 0 ? (
              <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                {subMenus.map((menu) => {
                  const childSubmenus = menus.filter(
                    (m) =>
                      m.menu_type === "S" &&
                      m.menu_root
                        .toString()
                        .startsWith(menu.menu_root.toString())
                  );

                  if (menu.menu_type === "M" && childSubmenus.length > 0) {
                    return (
                      <div key={menu.menu_id} className="mb-1">
                        <strong
                          style={{
                            fontSize: "0.75rem",
                            color: "#0d6efd",
                          }}
                        >
                          {menu.menu_desc}
                        </strong>
                        <div className="ms-3">
                          {childSubmenus.map((sub) => (
                            <div
                              key={sub.menu_id}
                              className="form-check form-check-sm"
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`submenu-${sub.menu_id}`}
                                checked={selectedSubMenus.some(
                                  (m) => m.menu_id === sub.menu_id
                                )}
                                onChange={() => handleSubMenuToggle(sub)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`submenu-${sub.menu_id}`}
                                style={{ fontSize: "0.75rem" }}
                              >
                                {sub.menu_desc}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  }

                  if (menu.menu_type === "M" && childSubmenus.length === 0) {
                    return (
                      <div key={menu.menu_id} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`menu-${menu.menu_id}`}
                          checked={selectedSubMenus.some(
                            (m) => m.menu_id === menu.menu_id
                          )}
                          onChange={() => handleSubMenuToggle(menu)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`menu-${menu.menu_id}`}
                          style={{ fontSize: "0.75rem" }}
                        >
                          {menu.menu_desc}
                        </label>
                      </div>
                    );
                  }

                  return null;
                })}
              </div>
            ) : (
              <p style={{ fontSize: "0.75rem" }}>
                Tidak ada sub menu untuk kategori ini.
              </p>
            )}
          </div>
        )}

        {/* Modal LOV User */}
        {showUserLov && (
          <LovUser
            show={showUserLov}
            data={users}
            onClose={() => setShowUserLov(false)}
            onSelect={(selected) => {
              setFormData({
                name: selected.name,
                username: selected.username,
                menu_id: "",
                menu_root: "",
                menu_desc: "",
              });
              setSelectedSubMenus([]);
              setShowUserLov(false);
              if (typeof onSelectUser === "function") {
                onSelectUser(selected);
              }
            }}
          />
        )}

        {/* Modal LOV Menu */}
        {showMenuLov && (
          <LovMenu
            show={showMenuLov}
            data={lovMenus}
            onClose={() => setShowMenuLov(false)}
            onSelect={(selected) => {
              setFormData({
                ...formData,
                menu_id: selected.menu_id,
                menu_root: selected.menu_root,
                menu_desc: selected.menu_desc,
              });
              setSelectedSubMenus([]);
              setShowMenuLov(false);
            }}
          />
        )}
      </div>

      {/* 🔹 Tombol Simpan di luar Card */}
      {formData.username && (
        <div className="text-end mt-4 mb-2 d-flex justify-content-end gap-3">
          {menus.length > 0 && (
            <button
              type="button"
              className="btn btn-sm btn-primary"
              style={{ fontSize: "0.8rem" }}
              onClick={() =>
                onSaveAccess &&
                onSaveAccess({
                  username: formData.username,
                  entry_by: user?.username,
                  selectedMenus: selectedSubMenus,
                })
              }
            >
              <i className="bx bx-save"></i> Simpan Akses
            </button>
          )}

          {menus.length > 0 && (
            <button
              type="button"
              className="btn btn-sm btn-success"
              style={{ fontSize: "0.8rem" }}
              onClick={() =>
                onSaveAll &&
                onSaveAll({
                  username: formData.username,
                  entry_by: user?.username,
                  selectedMenus: menus,
                })
              }
            >
              <i className="bx bx-save"></i> All Akses
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default DataMenu;
